export default __webpack_public_path__ + "static/media/video.d319bb2a.png";